<div class="filterPage scrollPage templatePage" *ngIf="isReadyToShow">

    <div class="row mr-0 ml-0">

        <!-- Search filter show / hide -->

        <div class="col-sm-8 border btn btn-lemken text-left" style="height:60px;padding-top:10px;" (click)="hideOrShowFilterPart()">
            <span class="ml-2 font-weight-bold" style="font-size:20px;">{{ 'filterPage.filterBy' | translate}}</span>
            <span class="float-right mr-6">
                <fa-icon icon="caret-down" size="2x" [fixedWidth]="true" *ngIf="!isShowFilterPart"></fa-icon>
                <fa-icon icon="caret-up" size="2x" [fixedWidth]="true" *ngIf="isShowFilterPart"></fa-icon>
            </span>
        </div>

        <!-- Reset filter -->

        <div class="col-sm-4 border text-justify btn btn-light font-weight-bold" style="height:60px;padding-top:15px;" (click)="resetFilter()">
            {{ 'filterPage.resetFilter' | translate}}
        </div>

        <!-- Know model question -->

        <div class="col-sm-8 mt-1 mb-1 text-left" style="padding-top:8px;" *ngIf="isShowFilterPart">
            <span class="ml-2 font-weight-bold">{{ 'filterPage.knowModel'|translate }}</span>
        </div>
        <div class="col-sm-4 mt-1 mb-1 btn-group" *ngIf="isShowFilterPart">
            <button type="button" class="btn btn-primary font-weight-bold" (click)="knowModelChoice(true)" [ngClass]="{'inactiveButton':knowModel!=2}">{{ 'settingPage.yes'|translate }}</button>
            <button type="button" class="btn btn-primary font-weight-bold" (click)="knowModelChoice(false)" [ngClass]="{'inactiveButton':knowModel!=1}">{{ 'settingPage.no'|translate }}</button>
        </div>

        <!-- Filter resume -->

        <div class="col-sm-12 border text-justify font-weight-bold text-lemken"
             *ngIf="!isShowFilterPart"
             (click)="hideOrShowFilterPart()">
            {{ filterResume }}
        </div>

        <!-- Type travail show / hide -->

        <div class="col-sm-12 border text-center btn btn-lemken font-weight-bold"
             *ngIf="isShowFilterPart && knowModel === 1"
             (click)="isShowTypeTravailFilters = !isShowTypeTravailFilters">
            <span>{{ 'filterPage.filterByWorkType' | translate}}</span>
            <span class="float-right">
                <fa-icon icon="caret-down" size="2x" [fixedWidth]="true" *ngIf="!isShowTypeTravailFilters"></fa-icon>
                <fa-icon icon="caret-up" size="2x" [fixedWidth]="true" *ngIf="isShowTypeTravailFilters"></fa-icon>
            </span>
        </div>

        <!-- Select type travail -->

        <div class="col-sm-5 border btn btn-light text-left" *ngIf="typeTravailFilterBlockExpanded()">
            <span class="ml-2 font-weight-bold">{{ 'filterPage.typeTravail' | translate}}</span>
        </div>
        <div class="col-sm-7 pl-0 border text-left" *ngIf="typeTravailFilterBlockExpanded()">
            <select class="form-control text-lemken font-weight-bold "
                    [(ngModel)]="userFilter.typeTravail"
                    name="inputTypeTravail"
                    (change)="eventSelectMachine()"
                    id="inputTypeTravail">
                <option [ngValue]="null" selected>{{'filterPage.toChooseTypeTravail' | translate}}</option>
                <option [ngValue]="item"
                        *ngFor="let item of typeTravailList">
                    {{ 'filterPage.' + item | translate}}
                </option>
            </select>
        </div>

        <!-- Type travail params -->

        <ng-template ngFor let-contentFilter
                     [ngForOf]="[userFilter.travailHerseFilter, userFilter.travailDisqueFilter, userFilter.travailDentFilter]"
                     *ngIf="typeTravailFilterBlockExpanded() && hasSelectedTypeTravail()">
            <div class="col-sm-5 border btn btn-light text-left" *ngIf="contentFilter.isFilter">
                <span class="ml-2 font-weight-bold">{{ contentFilter.labelCode | translate}}</span>
            </div>
            <div class="col-sm-7 pl-0 border text-left"
                 *ngIf="contentFilter.isFilter && contentFilter.codeValues.length > 1">
                <select class="form-control text-lemken font-weight-bold "
                        [(ngModel)]="contentFilter.selectedCode"
                        name="inputFilter"
                        (change)="eventSelectMachine()"
                >
                    <option [ngValue]="null" selected>{{contentFilter.labelSelectCode | translate}}</option>
                    <option [ngValue]="value.filterValue.code"
                            *ngFor="let value of contentFilter.codeValues">
                        {{ value.label}}
                    </option>
                </select>
            </div>
            <div class="col-sm-8 border btn btn-light text-left"
                 *ngIf="contentFilter.isFilter && contentFilter.codeValues.length == 1">
                <div class="text-lemken font-weight-bold">
                    {{ contentFilter.codeValues[0].label }}
                </div>
            </div>
        </ng-template>

        <!-- Machine show / hide -->

        <div class="col-sm-12 border text-center btn btn-lemken font-weight-bold"
             *ngIf="isVisibleMachineFilterBlock()"
             (click)="isShowMachineFilters = !isShowMachineFilters">
            <span>{{ 'filterPage.filterByMachine' | translate}}</span>
            <span class="float-right">
                <fa-icon icon="caret-down" size="2x" [fixedWidth]="true" *ngIf="!isShowMachineFilters"></fa-icon>
                <fa-icon icon="caret-up" size="2x" [fixedWidth]="true" *ngIf="isShowMachineFilters"></fa-icon>
            </span>
        </div>

        <!-- Machine -->

        <div class="col-sm-5 border btn btn-light text-left" *ngIf="machineFilterBlockExpanded()">
            <span class="ml-2 font-weight-bold">{{ 'filterPage.machine' | translate}}</span>
        </div>
        <div class="col-sm-7 pl-0 border text-left" *ngIf="machineFilterBlockExpanded()">
            <select class="form-control text-lemken font-weight-bold "
                    [(ngModel)]="userFilter.codeMachine"
                    name="inputMachine"
                    (change)="eventSelectMachine()"
                    id="inputMachine">
                <option [ngValue]="null" selected>{{'filterPage.toChooseMachine' | translate}}</option>
                <option [ngValue]="machine.code"
                        *ngFor="let machine of userFilter.filteredMachines">
                    {{ machine.nom}}
                </option>
            </select>
        </div>

        <!-- Portée, Largeur, Chassis -->

        <ng-template ngFor let-contentFilter
                     [ngForOf]="[userFilter.largeurFilter, userFilter.porteFilter, userFilter.chassisFilter]"
                     *ngIf="machineFilterBlockExpanded()">
            <div class="col-sm-5 border btn btn-light text-left" *ngIf="contentFilter.isFilter">
                <span class="ml-2 font-weight-bold">{{ contentFilter.labelCode | translate}}</span>
            </div>
            <div class="col-sm-7 pl-0 border text-left"
                 *ngIf="contentFilter.isFilter && contentFilter.codeValues.length > 1">
                <select class="form-control text-lemken font-weight-bold "
                        [(ngModel)]="contentFilter.selectedCode"
                        name="inputFilter"
                        (change)="eventSelectMachine(true)">
                    <option [ngValue]="null" selected>{{contentFilter.labelSelectCode | translate}}</option>
                    <option [ngValue]="value.filterValue.code"
                            *ngFor="let value of contentFilter.codeValues">
                        {{ value.label}}
                    </option>
                </select>
            </div>
            <div class="col-sm-7 border btn btn-light text-left"
                 *ngIf="contentFilter.isFilter && contentFilter.codeValues.length == 1">
                <div class="text-lemken font-weight-bold">
                    {{ contentFilter.codeValues[0].label }}
                </div>
            </div>
        </ng-template>

        <!-- Show / hide timon, herse, roue, semoir -->

        <div class="col-sm-12 border text-center btn btn-lemken font-weight-bold"
             *ngIf="isVisibleParamCompFreinageBlock()"
             (click)="isShowParamCompFreinageFilters = !isShowParamCompFreinageFilters">
            <span>{{ 'filterPage.paramCompFreinage' | translate}}</span>
            <span class="float-right">
                <fa-icon icon="caret-down" size="2x" [fixedWidth]="true" *ngIf="!isShowParamCompFreinageFilters"></fa-icon>
                <fa-icon icon="caret-up" size="2x" [fixedWidth]="true" *ngIf="isShowParamCompFreinageFilters"></fa-icon>
            </span>
        </div>

        <!-- Timon, herse, roue, semoir -->

        <ng-template ngFor let-contentFilter
                     [ngForOf]="[userFilter.timonFilter, userFilter.herseFilter, userFilter.roueFilter, userFilter.semoirFilter]"
                     *ngIf="paramCompFreinageBlockExpanded()">
            <div class="col-sm-5 border btn btn-light text-left" *ngIf="contentFilter.isFilter">
                <span class="ml-2 font-weight-bold">{{ contentFilter.labelCode | translate}}</span>
            </div>
            <div class="col-sm-7 pl-0 border text-left"
                 *ngIf="contentFilter.isFilter && contentFilter.codeValues.length > 1">
                <select class="form-control text-lemken font-weight-bold "
                        [(ngModel)]="contentFilter.selectedCode"
                        name="inputFilter"
                        (change)="eventSelectMachine()"
                >
                    <option [ngValue]="null" selected>{{contentFilter.labelSelectCode | translate}}</option>
                    <option [ngValue]="value.filterValue.code"
                            *ngFor="let value of contentFilter.codeValues">
                        {{ value.label}}
                    </option>
                </select>
            </div>
            <div class="col-sm-7 border btn btn-light text-left"
                 *ngIf="contentFilter.isFilter && contentFilter.codeValues.length == 1">
                <div class="text-lemken font-weight-bold">
                    {{ contentFilter.codeValues[0].label }}
                </div>
            </div>
        </ng-template>

        <!-- Show / hide type sol, utilisation ppale, utilisation secondaire -->

        <div class="col-sm-12 border text-center btn btn-lemken font-weight-bold"
             *ngIf="isVisibleMachineFilterBlock()"
             (click)="isShowConseilPertinanceFilters = !isShowConseilPertinanceFilters">
            <span>{{ 'filterPage.conseilPertinanceUtilisation' | translate}}</span>
            <span class="float-right">
                <fa-icon icon="caret-down" size="2x" [fixedWidth]="true" *ngIf="!isShowConseilPertinanceFilters"></fa-icon>
                <fa-icon icon="caret-up" size="2x" [fixedWidth]="true" *ngIf="isShowConseilPertinanceFilters"></fa-icon>
            </span>
        </div>

        <!-- Type sol -->

        <div class="col-sm-5 border btn btn-light text-left" *ngIf="conseilPertinanceBlockExpanded()">
            <span class="ml-2 font-weight-bold">{{ 'filterPage.typeSol' | translate}}</span>
        </div>
        <div class="col-sm-7 pl-0 border text-left" *ngIf="conseilPertinanceBlockExpanded()">
            <div class="text-lemken font-weight-bold">
                <ng-select
                        [items]="typeSolList"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="false"
                        bindLabel="name"
                        placeholder="{{ 'filterPage.toChooseSol'| translate}}"
                        (change)="eventSelectMachine()"
                        [(ngModel)]="userFilter.sols">
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                        <div class="bg-lemken text-white pr-2">
                            <span class="ng-value-icon left" (click)="clear(item);" aria-hidden="true">×</span>
                            {{ 'filterPage.' + item | translate}}
                        </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <div class="text-lemken pl-1">
                            {{ 'filterPage.' + item | translate}}
                        </div>
                    </ng-template>
                </ng-select>
            </div>
        </div>

        <!-- Usage 1 -->

        <div class="col-sm-5 border btn btn-light text-left" *ngIf="conseilPertinanceBlockExpanded()">
            <span class="ml-2 font-weight-bold">{{ 'filterPage.use1' | translate}}</span>
        </div>
        <div class="col-sm-7 pl-0 border text-left" *ngIf="conseilPertinanceBlockExpanded()">
            <div class="text-lemken font-weight-bold">
                <ng-select
                        [items]="utilisationList"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="false"
                        bindLabel="name"
                        placeholder="{{ 'filterPage.toChooseUse'| translate}}"
                        (change)="eventSelectMachine()"
                        [(ngModel)]="userFilter.utilisations1">
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                        <div class="bg-lemken text-white pr-2">
                            <span class="ng-value-icon left" (click)="clear(item);" aria-hidden="true">×</span>
                            {{ 'filterPage.' + item | translate}}
                        </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <div class="text-lemken pl-1">
                            {{ 'filterPage.' + item | translate}}
                        </div>
                    </ng-template>
                </ng-select>
            </div>
        </div>

        <!-- Usage 2 -->

        <div class="col-sm-5 border btn btn-light text-left" *ngIf="conseilPertinanceBlockExpanded()">
            <span class="ml-6 font-weight-bold">{{ 'filterPage.use2' | translate}}</span>
        </div>
        <div class="col-sm-7 pl-0 border text-left" *ngIf="conseilPertinanceBlockExpanded()">
            <div class="text-lemken font-weight-bold">
                <ng-select
                        [items]="utilisationList"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="false"
                        bindLabel="name"
                        placeholder="{{ 'filterPage.toChooseUse'| translate}}"
                        (change)="eventSelectMachine()"
                        [(ngModel)]="userFilter.utilisations2">
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                        <div class="bg-lemken text-white pr-2">
                            <span class="ng-value-icon left" (click)="clear(item);" aria-hidden="true">×</span>
                            {{ 'filterPage.' + item | translate}}
                        </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <div class="text-lemken pl-1">
                            {{ 'filterPage.' + item | translate}}
                        </div>
                    </ng-template>
                </ng-select>
            </div>
        </div>

        <!-- Num Rouleaux compatibles -->

        <div class="col-sm-4 border btn btn-light text-left">
            <span class="ml-2 font-weight-bold">{{ 'filterPage.compatibleRouleau' | translate}}</span>
        </div>
        <div class="col-sm-1 border btn btn-light text-center font-weight-bold">
            {{ filteredRouleauxBuffer.length }}
        </div>

        <!-- Voir rouleaux -->

        <div class="col-sm-7 border text-justify btn btn-lemken font-weight-bold" (click)="displayFilteredRouleaux()">
            {{ 'filterPage.voirRouleaux' | translate}}
        </div>

    </div>

    <div class="row mr-0 ml-0">

        <ng-template ngFor let-rouleau [ngForOf]="filteredRouleaux">
            <div class="col-sm-12" *ngIf="rouleau.viewDetail" [id]="'rouleau' + rouleau.rouleau.uuid">
                <div class="row">
                    <div class="col-sm-6  p-2  text-center">
                        <div class="border">
                            <div class="text-lemken font-weight-bold">
                                {{ rouleau.description.nom }}
                            </div>
                            <figure class="figure text-center">
                                <img moMediaSrcCache [mediaPath]="rouleau.rouleau.image"
                                     class="figure-img img-fluid rounded">
                            </figure>
                            <p class="ml-2 text-left">
                                {{ 'filterPage.wantedUse' | translate }} :
                                <mo-lemken-percentage [percentage]="rouleau.percentage"
                                                      class="h4 text-lemken font-weight-bold">
                                </mo-lemken-percentage>
                            </p>
                            <p class="ml-2 text-left" (click)="rouleau.viewSoilType = !rouleau.viewSoilType">
                                {{ 'filterPage.soilTypeUse' | translate }}
                                <span class="text-lemken">
                                    <fa-icon icon="caret-down" size="2x" [fixedWidth]="true" *ngIf="rouleau.viewSoilType"></fa-icon>
                                    <fa-icon icon="caret-up" size="2x" [fixedWidth]="true" *ngIf="!rouleau.viewSoilType"></fa-icon>
                                </span>
                            </p>
                            <table class="table table-sm table-borderless mt-2" *ngIf="rouleau.viewSoilType">
                                <thead>
                                <tr>
                                    <th colspan="3" class="text-center bg-lemken text-white border-white border-bottom">
                                        {{'filterPage.typeSol' | translate}}
                                    </th>
                                </tr>
                                <tr class="text-center bg-lemken text-white">
                                    <th>
                                        {{'filterPage.SOL_LOURD' | translate}}
                                    </th>
                                    <th>
                                        {{'filterPage.SOL_MOYEN' | translate}}
                                    </th>
                                    <th>
                                        {{'filterPage.SOL_LEGER' | translate}}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td colspan="3" class="text-center border-bottom">
                                        {{'filterPage.RAPPUYAGE_LIGNE' | translate}}
                                    </td>
                                </tr>
                                <tr class="text-lemken text-center">
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLourdRappuyageLigne"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solMoyenRappuyageLigne"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLegerRappuyageLigne"></mo-lemken-note>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="3" class="text-center border-bottom border-top">
                                        {{'filterPage.INSENSIBLE_COLLAGE' | translate}}
                                    </td>
                                </tr>
                                <tr class="text-lemken text-center">
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLourdInsCollage"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solMoyenInsCollage"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLegerInsCollage"></mo-lemken-note>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="3" class="text-center border-bottom border-top">
                                        {{'filterPage.INSENSIBLE_PIERRE' | translate}}
                                    </td>
                                </tr>
                                <tr class="text-lemken text-center">
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLourdInsPierres"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solMoyenInsPierres"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLegerInsPierres"></mo-lemken-note>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="3" class="text-center border-bottom border-top">
                                        {{'filterPage.NIVELLEMENT' | translate}}
                                    </td>
                                </tr>
                                <tr class="text-lemken text-center">
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLourdNivellement"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solMoyenNivellement"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLegerNivellement"></mo-lemken-note>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="3" class="text-center border-bottom border-top">
                                        {{'filterPage.PROFONDEUR' | translate}}
                                    </td>
                                </tr>
                                <tr class="text-lemken text-center">
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLourdCtrlProf"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solMoyenCtrlProf"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLegerCtrlProf"></mo-lemken-note>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="3" class="text-center border-bottom border-top">
                                        {{'filterPage.RAPPUYAGE' | translate}}
                                    </td>
                                </tr>
                                <tr class="text-lemken text-center">
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLourdRappuyage"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solMoyenRappuyage"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLegerRappuyage"></mo-lemken-note>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="3" class="text-center border-bottom border-top">
                                        {{'filterPage.ROULAGE' | translate}}
                                    </td>
                                </tr>
                                <tr class="text-lemken text-center">
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLourdRoulage"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solMoyenRoulage"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLegerRoulage"></mo-lemken-note>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="3" class="text-center border-bottom border-top">
                                        {{'filterPage.EMIETTEMENT' | translate}}
                                    </td>
                                </tr>
                                <tr class="text-lemken text-center border-bottom">
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLourdEmiettement"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solMoyenEmiettement"></mo-lemken-note>
                                    </td>
                                    <td>
                                        <mo-lemken-note [note]="rouleau.note.solLegerEmiettement"></mo-lemken-note>
                                    </td>
                                </tr>
                                </tbody>
                            </table >

                            <div class="text-justify p-2"
                                 [innerHTML]="rouleau.description.description">
                            </div>

                            <!-- Brake infos -->

                            <p class="ml-2 text-left">
                                {{ 'filterPage.requiredBrake' | translate }} :
                                <span class="text-lemken font-weight-bold">
                                    {{ getFreinageInfosFor(rouleau.rouleau.code) }}
                                </span>
                            </p>

                            <!-- Terres collantes -->

                            <p class="ml-2 text-left">
                                {{ 'filterPage.terresCollantes' | translate }} :
                                <mo-lemken-note [note]="rouleau.rouleau.terresCollantes"></mo-lemken-note>
                            </p>

                            <!-- Présence pierre -->

                            <p class="ml-2 text-left">
                                {{ 'filterPage.presencesPierres' | translate }} :
                                <mo-lemken-note [note]="rouleau.rouleau.presencesPierres"></mo-lemken-note>
                            </p>

                            <!-- Semi-porté ou pas -->

                            <p class="ml-2 text-left">
                                {{ 'filterPage.semiPorteOuPas' | translate }} :
                                <mo-lemken-note [note]="rouleau.rouleau.semiPorteOuPas"></mo-lemken-note>
                            </p>

                            <div class="text-left pb-1 mr-2 ml-2">

                                <ng-template ngFor let-attribut
                                             [ngForOf]=" [
                                             {key:'diametreRouleau', unit: 'cm'},
                                             {key:'diametreTube', unit: 'cm'},
                                             {key:'poids', unit: 'kg'}]">
                                    <div *ngIf="getRouleauProperty(rouleau.rouleau, attribut.key) != null && getRouleauProperty(rouleau.rouleau, attribut.key) !== ''">
                                    <span class="ml-0">{{ 'filterPage.' + attribut.key | translate }}</span> :
                                        <span class="text-lemken font-weight-bold">
                                            {{ getRouleauProperty(rouleau.rouleau, attribut.key) }}
                                            {{ 'filterPage.unit' + attribut.unit | translate }}
                                        </span>
                                    </div>
                                </ng-template>

                            </div>

                        </div>
                    </div>
                    <div class="col-sm-6 p-2 ">
                        <button type="button" class="btn btn-lemken float-right"
                                (click)="rouleau.viewDetail = false">
                            <fa-icon icon="times" size="1x" [fixedWidth]="true"></fa-icon>
                        </button>

                        <div class="border pl-2 pr-2">

                            <br/>
                            <br/>
                            <mo-lemken-info [infoTabs]="rouleau.infos"></mo-lemken-info>

                            <button type="button"
                                    class="btn btn-outline-lemken btn-block font-weight-bold text-left text-capitalize"
                                    (click)="addSelection(rouleau)"
                                    *ngIf="!rouleau.selected">
                                {{ 'filterPage.toCompare' | translate }}
                            </button>
                            <button type="button"
                                    class="btn btn-outline-danger btn-block  font-weight-bold text-left text-capitalize"
                                    (click)="removeSelection(rouleau)"
                                    *ngIf="rouleau.selected">
                                {{ 'filterPage.toUncompare' | translate }}
                            </button>
                            <button type="button"
                                    *ngIf="rouleau.docs.length > 0"
                                    (click)="gotoDoc(rouleau.docs[0])"
                                    class="btn btn-outline-lemken btn-block font-weight-bold text-left text-capitalize mb-2">
                                {{ 'filterPage.toGoDocs' | translate }}
                            </button>
                        </div>
                    </div>
                </div>

            </div>


            <div class="col-sm-6 text-center p-2" *ngIf="!rouleau.viewDetail">
                <div class="border">
                    <div class="text-lemken font-weight-bold">
                        {{ rouleau.description.nom }}
                    </div>
                    <figure class="figure text-center">
                        <img moMediaSrcCache [mediaPath]="rouleau.rouleau.image" class="figure-img img-fluid rounded">
                    </figure>
                    <div class="text-justify text-truncate text-wrap p-2" style="height: 150px;"
                         [innerHTML]="rouleau.description.description">
                    </div>

                    <!-- Rouleau double -->

                    <p class="ml-2 text-left text-lemken" *ngIf="rouleau.rouleau.rouleauxDouble">
                        {{ 'filterPage.chooseRouleauDouble' | translate }}
                    </p>

                    <!-- Brake infos -->

                    <p class="ml-2 text-left">
                        {{ 'filterPage.requiredBrake' | translate }} :
                        <span class="text-lemken font-weight-bold">
                            {{ getFreinageInfosFor(rouleau.rouleau.code) }}
                        </span>
                    </p>

                    <!-- Terres collantes -->

                    <p class="ml-2 text-left">
                        {{ 'filterPage.terresCollantes' | translate }} :
                        <mo-lemken-note [note]="rouleau.rouleau.terresCollantes"></mo-lemken-note>
                    </p>

                    <!-- Présence pierre -->

                    <p class="ml-2 text-left">
                        {{ 'filterPage.presencesPierres' | translate }} :
                        <mo-lemken-note [note]="rouleau.rouleau.presencesPierres"></mo-lemken-note>
                    </p>

                    <!-- Semi-porté ou pas -->

                    <p class="ml-2 text-left">
                        {{ 'filterPage.semiPorteOuPas' | translate }} :
                        <mo-lemken-note [note]="rouleau.rouleau.semiPorteOuPas"></mo-lemken-note>
                    </p>

                    <div class="row mr-0 ml-0">
                        <div class="col-4 text-left pl-0">
                            <button type="button" class="btn btn-lemken"
                                    (click)="showViewDetail(rouleau)">
                                <fa-icon icon="arrow-right" size="1x" [fixedWidth]="true"></fa-icon>
                            </button>
                        </div>
                        <div class="col-4">
                             <span class="text-lemken font-weight-bold">
                                <mo-lemken-percentage
                                        [percentage]="rouleau.percentage">
                                </mo-lemken-percentage>
                            </span>
                        </div>
                        <div class="col-4 text-right pr-0">
                            <button type="button" class="btn btn-secondary"
                                    (click)="addSelection(rouleau)"
                                    *ngIf="!rouleau.selected">
                                <!--
                                <fa-icon icon="plus" size="1x" [fixedWidth]="true"></fa-icon>
                                <fa-icon icon="chart-bar" size="1x" [fixedWidth]="true"></fa-icon>
                                -->
                                <fa-icon icon="balance-scale" size="1x" [fixedWidth]="true"></fa-icon>
                            </button>
                            <button type="button" class="btn btn-lemken"
                                    (click)="removeSelection(rouleau)"
                                    *ngIf="rouleau.selected">
                                <!--
                                <fa-icon icon="minus" size="1x" [fixedWidth]="true"></fa-icon>
                                <fa-icon icon="chart-bar" size="1x" [fixedWidth]="true"></fa-icon>
                                -->
                                <fa-icon icon="balance-scale" size="1x" [fixedWidth]="true"></fa-icon>
                            </button>
                        </div>
                    </div>


                </div>
            </div>

        </ng-template>

    </div>
</div>

<footer class="fixed-bottom">
    <app-data-validity-mention></app-data-validity-mention>
</footer>
